/* src/app/private/configrations/fee-breakdown/fee-breakdown.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
/*# sourceMappingURL=fee-breakdown.component.css.map */
